import React from "react";
import ImgHook from "./imgHook";
import LinkHook from "./linkHook";

const ImgLinkHook = (props) => {
    return(
        <LinkHook className={props.className} style={{display:'inline-block',position:'relative',zIndex:'1',backgroundImage:`url(${props.imgUrl})`,width:props.width,height:props.height,backgroundSize:'cover'}} {...props}/>
    );
}
export default ImgLinkHook